/**
 * @fileoverview 고객센터 문의글 API 함수
 * 고객센터의 문의글 목록 및 상세 조회를 위한 API 호출과 데이터 검증
 */

import { apiInstance } from "@core/api/axios/apiInstance";
import { getArticlesSchema, getArticleSchema, type GetArticlesType, ArticleIdType, GetArticleType, PaginationType } from "@features/helpdesk/model/getArticlesModel";
import { parseSchema } from "@core/model/parseSchema";

/**
 * 내 문의 내역 리스트
 * @param {PaginationType} params - 페이지네이션 파라미터
 * @param {number} params.page - 페이지 번호
 * @param {number} params.size - 페이지당 항목 수
 * @returns {Promise<GetArticlesType | null>} 문의글 목록 데이터 또는 null
 * @throws {Error} API 호출이 실패한 경우
 */
export const getArticles = async (params: PaginationType): Promise<GetArticlesType | null> => {
  const res = await apiInstance.get(`question/articles`, { params });
  return parseSchema<GetArticlesType>({
    schema: getArticlesSchema,
    rawData: res.data,
  });
};

/**
 * 내 문의 내역 상세
 * @param {Object} params - 문의글 조회 파라미터
 * @param {ArticleIdType} params.articleId - 조회할 문의글의 ID
 * @returns {Promise<GetArticleType | null>} 문의글 상세 데이터 또는 null
 * @throws {Error} API 호출이 실패한 경우
 */
export const getArticle = async (params: { articleId: ArticleIdType }): Promise<GetArticleType | null> => {
  const res = await apiInstance.get(`question/articles/${params.articleId}`);
  return parseSchema<GetArticleType>({
    schema: getArticleSchema,
    rawData: res.data,
  });
};
